module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ee.cf0f7217.png";